export const resetPasswordTranslations = {
  en: {
    resetPassword: "Reset password",
    password: "Password",
    repeatPassword: "Repeat password",
    passwordsDontMatch: "Passwords don't match or are too short",
    resetPasswordButton: "Reset password",
    discardButton: "Discard",
    passwordResetSuccess: "Password has been reset!",
    passwordResetSuccessMessage: "You have successfully reset your password.",
    loginButton: "Login",
  },
  cz: {
    resetPassword: "Resetovat heslo",
    password: "Heslo",
    repeatPassword: "Zopakujte heslo",
    passwordsDontMatch: "Hesla se nezhodují nebo jsou příliš krátká",
    resetPasswordButton: "Resetovat heslo",
    discardButton: "Zrušit",
    passwordResetSuccess: "Heslo bylo resetováno!",
    passwordResetSuccessMessage: "Úspěšně jste resetovali své heslo.",
    loginButton: "Přihlásit se",
  },
  ru: {
    resetPassword: "Сбросить пароль",
    password: "Пароль",
    repeatPassword: "Повторите пароль",
    passwordsDontMatch: "Пароли не совпадают или слишком короткие",
    resetPasswordButton: "Сбросить пароль",
    discardButton: "Отменить",
    passwordResetSuccess: "Пароль был сброшен!",
    passwordResetSuccessMessage: "Вы успешно сбросили пароль.",
    loginButton: "Войти",
  },
  fr: {
    resetPassword: "Réinitialiser le mot de passe",
    password: "Mot de passe",
    repeatPassword: "Répéter le mot de passe",
    passwordsDontMatch:
      "Les mots de passe ne correspondent pas ou sont trop courts",
    resetPasswordButton: "Réinitialiser le mot de passe",
    discardButton: "Annuler",
    passwordResetSuccess: "Le mot de passe a été réinitialisé!",
    passwordResetSuccessMessage:
      "Vous avez réinitialisé votre mot de passe avec succès.",
    loginButton: "Connexion",
  },
  es: {
    resetPassword: "Restablecer la contraseña",
    password: "Contraseña",
    repeatPassword: "Repetir la contraseña",
    passwordsDontMatch: "Las contraseñas no coinciden o son demasiado cortas",
    resetPasswordButton: "Restablecer la contraseña",
    discardButton: "Descartar",
    passwordResetSuccess: "¡La contraseña ha sido restablecida!",
    passwordResetSuccessMessage: "Has restablecido tu contraseña con éxito.",
    loginButton: "Iniciar sesión",
  },
  nl: {
    resetPassword: "Wachtwoord opnieuw instellen",
    password: "Wachtwoord",
    repeatPassword: "Herhaal wachtwoord",
    passwordsDontMatch: "Wachtwoorden komen niet overeen of zijn te kort",
    resetPasswordButton: "Wachtwoord opnieuw instellen",
    discardButton: "Annuleren",
    passwordResetSuccess: "Wachtwoord is opnieuw ingesteld!",
    passwordResetSuccessMessage:
      "U heeft uw wachtwoord succesvol opnieuw ingesteld.",
    loginButton: "Inloggen",
  },
  sk: {
    resetPassword: "Obnoviť heslo",
    password: "Heslo",
    repeatPassword: "Zopakujte heslo",
    passwordsDontMatch: "Heslá sa nezhodujú alebo sú príliš krátke",
    resetPasswordButton: "Obnoviť heslo",
    discardButton: "Zrušiť",
    passwordResetSuccess: "Heslo bolo obnovené!",
    passwordResetSuccessMessage: "Úspešne ste obnovili svoje heslo.",
    loginButton: "Prihlásiť sa",
  },
  de: {
    resetPassword: "Passwort zurücksetzen",
    password: "Passwort",
    repeatPassword: "Passwort wiederholen",
    passwordsDontMatch: "Passwörter stimmen nicht überein oder sind zu kurz",
    resetPasswordButton: "Passwort zurücksetzen",
    discardButton: "Verwerfen",
    passwordResetSuccess: "Passwort wurde zurückgesetzt!",
    passwordResetSuccessMessage:
      "Sie haben Ihr Passwort erfolgreich zurückgesetzt.",
    loginButton: "Anmelden",
  },
  hu: {
    resetPassword: "Jelszó visszaállítása",
    password: "Jelszó",
    repeatPassword: "Jelszó ismétlése",
    passwordsDontMatch: "A jelszavak nem egyeznek vagy túl rövidek",
    resetPasswordButton: "Jelszó visszaállítása",
    discardButton: "Elvet",
    passwordResetSuccess: "A jelszó vissza lett állítva!",
    passwordResetSuccessMessage: "Sikeresen visszaállította a jelszavát.",
    loginButton: "Bejelentkezés",
  },
  pl: {
    resetPassword: "Zresetuj hasło",
    password: "Hasło",
    repeatPassword: "Powtórz hasło",
    passwordsDontMatch: "Hasła nie pasują lub są za krótkie",
    resetPasswordButton: "Zresetuj hasło",
    discardButton: "Anuluj",
    passwordResetSuccess: "Hasło zostało zresetowane!",
    passwordResetSuccessMessage: "Pomyślnie zresetowałeś hasło.",
    loginButton: "Zaloguj się",
  },
  sv: {
    resetPassword: "Återställ lösenord",
    password: "Lösenord",
    repeatPassword: "Upprepa lösenord",
    passwordsDontMatch: "Lösenorden stämmer inte överens eller är för korta",
    resetPasswordButton: "Återställ lösenord",
    discardButton: "Avbryt",
    passwordResetSuccess: "Lösenordet har återställts!",
    passwordResetSuccessMessage:
      "Du har framgångsrikt återställt ditt lösenord.",
    loginButton: "Logga in",
  },
  no: {
    resetPassword: "Tilbakestill passord",
    password: "Passord",
    repeatPassword: "Gjenta passord",
    passwordsDontMatch: "Passordene stemmer ikke eller er for korte",
    resetPasswordButton: "Tilbakestill passord",
    discardButton: "Forkast",
    passwordResetSuccess: "Passordet er tilbakestilt!",
    passwordResetSuccessMessage: "Du har tilbakestilt passordet ditt.",
    loginButton: "Logg inn",
  },
  da: {
    resetPassword: "Nulstil adgangskode",
    password: "Adgangskode",
    repeatPassword: "Gentag adgangskode",
    passwordsDontMatch:
      "Adgangskoderne stemmer ikke overens eller er for korte",
    resetPasswordButton: "Nulstil adgangskode",
    discardButton: "Kassér",
    passwordResetSuccess: "Adgangskoden er blevet nulstillet!",
    passwordResetSuccessMessage: "Du har nulstillet din adgangskode.",
    loginButton: "Log ind",
  },
  fi: {
    resetPassword: "Palauta salasana",
    password: "Salasana",
    repeatPassword: "Toista salasana",
    passwordsDontMatch: "Salasanat eivät täsmää tai ovat liian lyhyitä",
    resetPasswordButton: "Palauta salasana",
    discardButton: "Hylkää",
    passwordResetSuccess: "Salasana on palautettu!",
    passwordResetSuccessMessage: "Olet palauttanut salasanasi onnistuneesti.",
    loginButton: "Kirjaudu sisään",
  },
  ar: {
    resetPassword: "إعادة تعيين كلمة المرور",
    password: "كلمة المرور",
    repeatPassword: "أعد كلمة المرور",
    passwordsDontMatch: "كلمات المرور غير متطابقة أو قصيرة جدًا",
    resetPasswordButton: "إعادة تعيين كلمة المرور",
    discardButton: "تجاهل",
    passwordResetSuccess: "تم إعادة تعيين كلمة المرور!",
    passwordResetSuccessMessage:
      "لقد نجحت في إعادة تعيين كلمة المرور الخاصة بك.",
    loginButton: "تسجيل الدخول",
  },
};

export default resetPasswordTranslations;
